module.exports = __webpack_public_path__ + "files/904babc69163fd15f0f43929e34b05dc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/logo.png
 ** module id = 140
 ** module chunks = 0
 **/